import React from 'react';
import PropTypes from 'prop-types';
import capitalize from 'lodash/capitalize';
import { costFormatter } from '@format/currency';
import {
  DescriptionList,
  DescriptionListLabel,
  DescriptionListValue,
  HorizontalRule,
} from '@web/atoms';
import { SummaryCard } from '../SummaryCard';
import { AddonsSummary } from '../AddonsSummary';
import { HALF_PORTION } from '../../products/constants';
import {
  BoldText,
  Headline,
  LightText,
  Price,
  PriceWithDiscount,
  Pricing,
  StyledStarterBoxCheckoutSummary,
  SummaryCardContent,
} from './styles.js';
import { CheckoutSummaryDisplayRecipes } from './components';

export const StarterBoxCheckoutSummary = ({
  avatarBgColor,
  breeds,
  headline,
  nextDeliveryDate,
  numPacksCopy,
  bagCount,
  productType,
  recipes,
  petId,
  pricePerPeriod,
  pricePerPeriodWithDiscount,
  period,
  onDeletePet,
  addons,
  portionSize,
  mealCount,
  isSubmitting,
}) => {
  period = capitalize(period);

  let portionText;
  switch (portionSize) {
    case HALF_PORTION:
      portionText = 'Half';
      break;
    default:
      portionText = 'Full';
  }

  return (
    <StyledStarterBoxCheckoutSummary>
      <SummaryCard
        avatarBgColor={avatarBgColor}
        breeds={breeds}
        onDeletePet={onDeletePet}
        petId={petId}
        isSubmitting={isSubmitting}
      >
        <SummaryCardContent>
          <Headline>{headline}</Headline>
          <Pricing>
            <Price>{costFormatter(pricePerPeriod) + '/' + period}</Price>
            {pricePerPeriodWithDiscount !== '0.00' ? (
              <PriceWithDiscount>
                {costFormatter(pricePerPeriodWithDiscount) + '/' + period}
              </PriceWithDiscount>
            ) : (
              <PriceWithDiscount>
                {costFormatter(pricePerPeriodWithDiscount)}
              </PriceWithDiscount>
            )}
          </Pricing>
        </SummaryCardContent>
      </SummaryCard>
      <HorizontalRule />
      <DescriptionList>
        <DescriptionListLabel>{'Preparation'}</DescriptionListLabel>
        <DescriptionListValue>
          {productType === 'FR' && (
            <BoldText>{portionText} Fresh Plan</BoldText>
          )}
          {productType === 'DY' && (
            <BoldText>{portionText} Baked Plan</BoldText>
          )}
          {productType === 'MX' && <BoldText>Mixed Bowl Plan</BoldText>}
        </DescriptionListValue>
        <CheckoutSummaryDisplayRecipes
          productType={productType}
          recipes={recipes}
          numPacksCopy={numPacksCopy}
          bagCount={bagCount}
        />
        {period === 'Meal' && (
          <>
            <DescriptionListLabel>No. of meals:</DescriptionListLabel>
            <DescriptionListValue>
              <BoldText>{mealCount} meals</BoldText>
            </DescriptionListValue>
          </>
        )}
      </DescriptionList>
      {addons?.length > 0 && (
        <>
          <HorizontalRule />
          <AddonsSummary petId={petId} addons={addons} />
        </>
      )}
      <HorizontalRule />
      <DescriptionList>
        <DescriptionListLabel>Estimated Delivery</DescriptionListLabel>
        <DescriptionListValue>
          {nextDeliveryDate ? (
            <BoldText>{nextDeliveryDate}</BoldText>
          ) : (
            <LightText>Enter Address</LightText>
          )}
        </DescriptionListValue>
      </DescriptionList>
    </StyledStarterBoxCheckoutSummary>
  );
};
StarterBoxCheckoutSummary.displayName = 'StarterBoxCheckoutSummary';
StarterBoxCheckoutSummary.propTypes = {
  avatarBgColor: PropTypes.string.isRequired,
  breeds: PropTypes.arrayOf(PropTypes.string).isRequired,
  headline: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
  recipes: PropTypes.object.isRequired,
  pricePerPeriod: PropTypes.string.isRequired,
  pricePerPeriodWithDiscount: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  onDeletePet: PropTypes.func,
  nextDeliveryDate: PropTypes.string,
  numPacksCopy: PropTypes.string.isRequired,
  bagCount: PropTypes.number.isRequired,
  mealCount: PropTypes.number.isRequired,
  petId: PropTypes.string,
  addons: PropTypes.array,
  portionSize: PropTypes.string,
  isSubmitting: PropTypes.bool,
};
